import React from 'react';
import { Icon, Menu } from 'antd';
import { connect } from 'dva';
import { withRouter } from 'dva/router';
import { injectIntl, FormattedMessage } from 'react-intl';
import pathToRegexp from 'path-to-regexp';
import helpers from '../../utils/helpers';
import { NavModules } from '../index';
import routes from '../../routes';
import { userRoleInCurrentProject } from '../../selectors/app';
import Roles from '../../utils/roles';
import styles from './styles.less';
import config from '../../config';

export const MENU_LEAD_SCORING_LIST = 'LEAD_SCORING_LIST';
export const MENU_PAGE_GROUPS_LIST = 'PAGE_GROUPS_LIST';
export const MENU_COUNTRY_REGIONS = 'COUNTRY_REGIONS';
export const MENU_CATEGORIES_LIST = 'CATEGORIES_LIST';
export const MENU_BRANCHES_LIST = 'BRANCHES_LIST';
export const MENU_USERS_LIST = 'USERS_LIST';
export const MENU_AI_OUTREACH_AGENTS_LIST = 'AI_OUTREACH_AGENTS_LIST';
export const MENU_ACCOUNTS_LIST = 'ACCOUNTS_LIST';
export const MENU_LEAD_LABELS_LIST = 'LEAD_LABELS_LIST';
export const MENU_LEAD_VISITS_LIST = 'LEAD_VISITS_LIST';
export const MENU_COMPANIES_LIST = 'COMPANIES_LIST';
export const MENU_TARGET_GROUPS_LIST = 'TARGET_GROUPS_LIST';
export const MENU_LEAD_COMPANIES_LIST = 'LEAD_COMPANIES_LIST';
export const MENU_CAMPAIGNS_LIST = 'CAMPAIGNS_LIST';

class NavMenu extends React.Component {
  static SUB_MENUS = {
    SETTINGS: [
      MENU_LEAD_LABELS_LIST,
      MENU_BRANCHES_LIST,
      MENU_LEAD_SCORING_LIST,
      MENU_PAGE_GROUPS_LIST,
      MENU_CATEGORIES_LIST,
      MENU_COMPANIES_LIST,
      MENU_COUNTRY_REGIONS,
      MENU_USERS_LIST,
      MENU_AI_OUTREACH_AGENTS_LIST,
      MENU_ACCOUNTS_LIST,
      MENU_CAMPAIGNS_LIST,
    ],
    LEAD_MANAGEMENT: [
      MENU_LEAD_VISITS_LIST,
      MENU_LEAD_COMPANIES_LIST,
    ],
  };

  constructor(props) {
    super(props);

    this.projectId = null;

    this.state = {
      navMenuItems: [],
      menuItems: [
        {
          key: MENU_LEAD_LABELS_LIST,
          label: this.props.intl.formatMessage({
            id: 'Component.Settings.LeadLabels.Label',
          }),
          roles: [Roles.role_super_admin.id],
        },
        {
          key: MENU_BRANCHES_LIST,
          label: this.props.intl.formatMessage({
            id: 'Component.Branches.List.Title',
          }),
          roles: [Roles.role_super_admin.id],
        },
        {
          key: MENU_LEAD_SCORING_LIST,
          label: this.props.intl.formatMessage({
            id: 'Component.Settings.LeadScoring.List.Label',
          }),
          roles: [
            Roles.role_super_admin.id,
            Roles.role_admin.id,
            Roles.role_editor.id,
          ],
        },
        {
          key: MENU_PAGE_GROUPS_LIST,
          label: this.props.intl.formatMessage({
            id: 'Component.PageGroups.Title',
          }),
          roles: [
            Roles.role_super_admin.id,
            Roles.role_admin.id,
            Roles.role_editor.id,
          ],
        },
        {
          key: MENU_CATEGORIES_LIST,
          label: this.props.intl.formatMessage({
            id: 'Component.Categories.List.Title',
          }),
          roles: [Roles.role_super_admin.id],
        },
        {
          key: MENU_CAMPAIGNS_LIST,
          label: this.props.intl.formatMessage({
            id: 'Component.NavMenu.Campaigns.Overview',
          }),
          roles: [
            Roles.role_super_admin.id,
            Roles.role_admin.id,
            Roles.role_editor.id,
          ],
        },
        {
          key: MENU_COMPANIES_LIST,
          label: this.props.intl.formatMessage({
            id: 'Component.NavMenu.Companies.Overview',
          }),
          roles: [
            Roles.role_super_admin.id,
            Roles.role_admin.id,
            Roles.role_editor.id,
          ],
        },
        {
          key: MENU_COUNTRY_REGIONS,
          label: this.props.intl.formatMessage({
            id: 'Component.CountryRegions.Title',
          }),
          roles: [Roles.role_super_admin.id],
        },
        {
          key: MENU_AI_OUTREACH_AGENTS_LIST,
          label: this.props.intl.formatMessage({
            id: 'Component.AIOutreachAgents.List.Title',
          }),
          roles: [
            Roles.role_super_admin.id,
            Roles.role_admin.id,
          ],
        },
        {
          key: MENU_ACCOUNTS_LIST,
          label: this.props.intl.formatMessage({
            id: 'Component.AccountSettings.List.Title',
          }),
          roles: [Roles.role_super_admin.id, Roles.role_admin.id],
        },
        {
          key: MENU_USERS_LIST,
          label: this.props.intl.formatMessage({
            id: 'Component.User.Administration.Title',
          }),
          roles: [Roles.role_super_admin.id, Roles.role_admin.id],
        },
      ],
    };
  }

  componentWillMount() {
    return this.updateMenuState();
  }

  componentWillReceiveProps(nextProps) {
    // update only on project switch or update any project settings
    if (
      nextProps.app.currentProjectId !== this.props.app.currentProjectId ||
      JSON.stringify(nextProps.app.projects) !==
      JSON.stringify(this.props.app.projects)
    ) {
      this.updateMenuState(nextProps);
    }
  }

  onMenuSelect({ key }) {
    if (key === 'LOGOUT') {
      this.logout();
    } else {
      this.props.dispatch({
        type: 'app/goToRoute',
        payload: {
          routeName: key,
          projectId: this.projectId,
        },
      });
    }
  }

  getCssClassName() {
    return [
      styles.navMenu,
      helpers.isHomePath(this.props.app.location.pathname)
        ? styles.noneSelected
        : '',
    ].join(' ');
  }

  logout() {
    this.props.dispatch({
      type: 'app/logout',
    });
  }

  updateMenuState(nextProps) {
    const currentProps = nextProps || this.props;
    const pId = currentProps.app.currentProjectId;
    const projects = currentProps.app.projects;

    if (!projects.length || !pId) {
      return false;
    }

    const currentProject = projects.find((project) => {
      return project.id === pId;
    });

    this.projectId = pId;

    const modules = currentProject.modules;
    const dynamicMenuItems = NavModules();

    const navMenuItems = modules.map((module) => {
      return module.disabled ?
        null :
        dynamicMenuItems[module.code] ? dynamicMenuItems[module.code].navItem : null;
    });
    this.setState({ navMenuItems });
  }

  isSubmenuVisibleForRole(userRole) {
    return this.state.menuItems.some(item => !!item.roles.includes(userRole));
  }

  render() {
    const SubMenu = Menu.SubMenu;
    const pathname = this.props.app.location.pathname;
    const subMenus = this.constructor.SUB_MENUS;
    const selectedKeys = [];
    const openKeys = [];
    const { app, userRole } = this.props;
    const menuItems = this.state.menuItems
      .filter(item => item.roles.includes(userRole))
      .filter((item) => {
        if (item.key === MENU_AI_OUTREACH_AGENTS_LIST) {
          return config['features.ai_outreach_agents'];
        }
        // all, except not branches when no customer branches must be used
        return !(item.key === MENU_BRANCHES_LIST && app.useCustomBranches === false);
      });

    Object.keys(routes).forEach((r) => {
      const route = routes[r];
      const routeKey = route.parent || r;

      if (pathToRegexp(route.path).test(pathname)) {
        selectedKeys.push(routeKey);

        Object.keys(subMenus).forEach((subMenuKey) => {
          if (subMenus[subMenuKey].includes(routeKey)) {
            openKeys.push(subMenuKey);
          }
        });
      }
    });
    return (
      <Menu
        selectedKeys={selectedKeys}
        defaultOpenKeys={this.props.collapsed ? null : openKeys}
        mode="inline"
        theme="light"
        onClick={this.onMenuSelect.bind(this)}
        onSelect={this.props.onSelect}
        className={this.getCssClassName()}
        key={this.props.app.currentProjectId}
      >
        {this.state.navMenuItems}
        {this.isSubmenuVisibleForRole(userRole) && (
          <SubMenu
            key="SETTINGS"
            title={
              <span>
                <Icon
                  className={[styles.navMenuIcon, styles.itemSettings].join(
                    ' ',
                  )}
                />
                <FormattedMessage id="Component.NavMenu.Settings" />
              </span>
            }
          >
            {menuItems.map(item => (
              <Menu.Item key={item.key}>{item.label}</Menu.Item>
            ))}
          </SubMenu>
        )}
        <Menu.Item key="LOGOUT">
          <span>
            <Icon
              className={[styles.navMenuIcon, styles.itemLogout].join(' ')}
            />
            <FormattedMessage id="Component.NavMenu.Logout" />
          </span>
        </Menu.Item>
      </Menu>
    );
  }
}

export default withRouter(
  connect(({ app }) => ({ app, userRole: userRoleInCurrentProject(app) }))(
    injectIntl(NavMenu),
  ),
);



// WEBPACK FOOTER //
// ./src/components/NavMenu/NavMenu.js